/**
 * Konstelacja w polu omniboksa — **trzy gwiazdy połączone linią** (wariant P1).
 *
 * ⭐ Nie jest teksturą ani tłem, tylko **rysunkiem: punkty i krawędzie**, czyli tym samym
 * kształtem, co graf pod spodem. Drzewko nazywa się `Constellation` (decyzja 29), więc
 * gwiazdozbiór jest u nas obrazem modelu danych, nie ozdobą wziętą z nastroju.
 *
 * ⚠ **Stoi jako element układu, a nie jako tło pola** — i to jest różnica merytoryczna,
 * nie porządkowa. Tło rozciągane na całą szerokość albo wchodzi pod wpisywany tekst,
 * albo trzeba je tłumić przezroczystością do niewidoczności. Jako element w rzędzie
 * konstelacja siedzi **w luce między napisem i pigułkami**, więc **nie może** wejść pod
 * literę — gwarantuje to układ, a nie ustawienie krycia.
 *
 * Barwa: rola `--star`, **odwrócona między motywami** (ciemne punkty na jasnym, świecące
 * na ciemnym). Motywem nie jest „czarne niebo", tylko **atlas nieba** — inaczej ten sam
 * rysunek nie przeżyłby obu tł.
 */
// ⚠ `string | undefined`, a nie `string?`: klasy z CSS Modules są przy
// `noUncheckedIndexedAccess` typowane jako możliwie niezdefiniowane, a
// `exactOptionalPropertyTypes` nie pozwala wtedy podać ich pod `?`.
export function OmniboxSky({ className }: { className?: string | undefined }) {
  return (
    <svg
      className={className}
      width="116"
      height="32"
      viewBox="0 0 116 32"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M14 10L58 24L102 9"
        fill="none"
        stroke="var(--star)"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.4"
      />
      <g fill="var(--star)" opacity="0.7">
        <path d="M14 6.4Q14.68 9.32 17.6 10Q14.68 10.68 14 13.6Q13.32 10.68 10.4 10Q13.32 9.32 14 6.4Z" />
        <path d="M58 18.4Q59.06 22.94 63.6 24Q59.06 25.06 58 29.6Q56.94 25.06 52.4 24Q56.94 22.94 58 18.4Z" />
        <path d="M102 5.8Q102.61 8.39 105.2 9Q102.61 9.61 102 12.2Q101.39 9.61 98.8 9Q101.39 8.39 102 5.8Z" />
      </g>
    </svg>
  );
}
